import { CustomImage, ProgressIndicator } from "@veneer/core";
import imageNotFound from "../../../../assets/img/courses/default_image.png";
import React from "react";

interface CourseCardImageProps {
  imagesLoaded: boolean;
  imageUrl?: string;
}

export const CourseCardImage: React.FC<CourseCardImageProps> = ({
  imagesLoaded,
  imageUrl,
}) => {
  return (
    <div className="coursesContentCardsImageDiv">
      {!imagesLoaded && (
        <ProgressIndicator appearance="circular" behavior="indeterminate" />
      )}

      {imagesLoaded && imageUrl && (
        <CustomImage
          size={180}
          className="coursesContentCardsImage"
          src={imageUrl}
        />
      )}

      {imagesLoaded && !imageUrl && (
        <CustomImage
          size={180}
          className="coursesContentCardsImage"
          src={imageNotFound}
        />
      )}
    </div>
  );
};
